import { Dispute } from '@/types/transactions/dispute'

export const dispute1: Dispute = {
    id: 1_234,
    date_time: '2025-06-29T21:58:08Z',
}

export const dispute2: Dispute = {
    id: 1_235,
    date_time: '2025-05-29T21:58:08Z',
}
